<template>
<v-card>
  <request-status
    :request='request'
    :message200="false"
    @ok="$emit('success')" />
  <v-card-title class="py-0 grey lighten-4" >
    <v-btn icon small
      :loading="request.loading"
      @click="get" ><v-icon small >replay</v-icon></v-btn>
    Form settings
    <v-spacer/>

    <v-btn icon small @click="$emit('close')" >
      <v-icon small >close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>

  <space-picker multiple
    v-model="spaces"
    label="Which spaces do you want to use this form in?"
    :with-select='false' />


  <v-card-text
    class="pt-0" >

    <template v-if="form && form.products" >
      <template v-if="products.length === 0" >
      <span class="info--text caption" >Form is shared on all appointment types</span>
      <v-btn @click="showproductpicker=true" small text flat >edit</v-btn>
      </template>
      <template v-else >

        <product-chips with-space-name :product-ids="form.products" class="my-3" @selected="showproductpicker=true" >
          <template slot="before" >Only shown for: </template>
          <v-btn slot="after" @click="showproductpicker=true" small text flat >edit</v-btn>
        </product-chips>
      </template>
      <v-dialog v-model="showproductpicker" >
        <v-card flat>
          <v-card-title class='subtitle-1 overline py-1 grey lighten-4' >
            Choose appointment types
            <v-spacer/>
            <v-btn small outline color="primary"
              @click="save();showproductpicker=false" >Save</v-btn>
            <v-btn icon small @click="showproductpicker=false" ><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-alert type="info" tile outlined
            class="ma-0 pa-2 caption"
            :value="true" >
            Select products below to only show this form for those specific products
          </v-alert>
          <product-tree-picker expanded v-model="form.products" :space-ids="spaces" />

          <v-divider/>
          <v-card-actions >
            <v-btn @click="showproductpicker=false" flat >Close</v-btn>
            <v-spacer />
            <v-btn color="primary" @click="save();showproductpicker=false" >Save and close</v-btn>
          </v-card-actions>
        </v-card>

      </v-dialog>
    </template>

    <!-- <pre v-text="form" class="caption grey lighten-4 pa-3" /> -->

    <v-checkbox persistent-hint
      v-model="withLink"
      label="Link this form"
      hint="Include a link to this form in notifications, on the client appointment information page and in your appointment link page" />

    <v-textarea outline persistent-hint class="mt-3"
      v-model="description"
      label="Form description"
      hint="You can add a description to give the client some context on this form - e.g.: you only need to full in this form for a certain appointment type" />

    <v-text-field
      type="number"
      label="display order"
      hint="The order in which this form will be displayed to the client"
      v-model="form.order" />
  </v-card-text>
  <!-- <pre v-text="form" /> -->
  <v-card-actions >
    <v-btn @click="$emit('close')" flat >Done</v-btn>
    <v-spacer />
    <v-btn flat @click="withClose=true;save()"
      :loading="request.loading" >Save and close</v-btn>
    <v-btn @click="save"
      :loading="request.loading"
      color="primary" >Save</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import ProductTreePicker from '@/components/pickers/ProductTreePicker.vue'
import ProductChips from '@/components/ui/ProductChips.vue'
export default {
  name: 'FormSettings',
  components: {SpacePicker, ProductTreePicker, ProductChips},
  props: {
    formId: { required: true }
  },
  data () {
    return {
      withClose: false,
      withLink: true,
      description: null,
      spaces: [],
      request: {
        resource: 'ag.spaces.forms',
        data: {
        }
      },
      showproductpicker: false
    }
  },
  watch: {
    formId: {
      immediate: true,
      handler () {
        if (this.formId) { this.get() }
      }
    },
    requestStatus () {
      if (this.requestStatus === 200 && this.form) {
        this.withLink = this.form.include_on_appointment_page
        this.description = this.form.description
        this.spaces = this.form.spaces
        if (this.withClose) {
          this.withClose = false
          this.$emit('close')
        }
      }
    }
  },
  computed: {
    form () {
      return this.getObjectPath(this.request, 'result', {})
    },
    products () { return this.getObjectPath(this.form, 'products', []) },
    requestStatus () { return this.request.status }
  },
  methods: {
    get () {
      this.request.resourceId = this.formId
      this.$request('get', this.request)
    },
    save () {
      this.request.resourceId = this.formId
      this.request.data = {
        include_on_appointment_page: this.withLink,
        description: this.description,
        spaces: this.spaces,
        products: this.products,
        order: this.form.order
      }
      // if (this.products && this.products.length === 0) {
      //   this.request.data['products'] = null
      // }
      if (this.form && this.form.order) {
        this.request.data['order'] = this.form.order
      }
      this.$request('save', this.request)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormSettings.vue?61d0370e